<template>
  <div class="field-image">
    <!-- Input de archivo -->
    <input
      type="file"
      accept="image/*"
      :multiple="field.isArray"
      :id="fieldId"
      class="form-control"
      style="background: none"
      @change="onFileChange"
    />

    <!-- Vista previa para imagen única -->
    <div
      v-if="!field.isArray && value && typeof value === 'string'"
      class="mt-2 position-relative d-inline-block"
    >
      <img
        :src="value"
        alt="Preview"
        style="max-width: 150px; max-height: 150px"
      />
      <button
        type="button"
        class="btn btn-danger btn-sm position-absolute"
        style="top: 5px; right: 5px"
        @click="removeImage()"
      >
        <i class="material-icons">close</i>
      </button>
    </div>

    <!-- Vista previa para múltiples imágenes -->
    <div
      v-if="field.isArray && Array.isArray(value) && value.length > 0"
      class="mt-2 d-flex flex-wrap gap-2"
    >
      <div
        v-for="(img, index) in value"
        :key="index"
        class="position-relative d-inline-block"
      >
        <img
          :src="img"
          :alt="'Preview ' + (index + 1)"
          style="max-width: 150px; max-height: 150px; object-fit: cover; border-radius: 4px;"
        />
        <button
          type="button"
          class="btn btn-danger btn-sm position-absolute"
          style="top: 5px; right: 5px; padding: 2px 6px;"
          @click="removeImageAt(index)"
        >
          <i class="material-icons" style="font-size: 16px;">close</i>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "FieldImage",
  props: {
    value: {
      type: [String, Array],
      default: null,
    },
    field: {
      type: Object,
      required: true,
    },
    fieldId: {
      type: String,
      default: "",
    },
  },
  methods: {
    onFileChange(event) {
      const files = Array.from(event.target.files);
      if (!files.length) return;

      if (this.field.isArray) {
        // Múltiples imágenes
        const validFiles = [];
        const previews = Array.isArray(this.value) ? [...this.value] : [];

        for (const file of files) {
          // Validar tamaño (5MB máximo)
          if (file.size > 5 * 1024 * 1024) {
            this.$swal?.fire?.({
              title: "Error",
              text: `El archivo "${file.name}" es demasiado grande. El tamaño máximo permitido es 5MB.`,
              icon: "error",
            });
            continue;
          }

          // Validar tipo de archivo
          if (!file.type.startsWith("image/")) {
            this.$swal?.fire?.({
              title: "Error",
              text: `El archivo "${file.name}" no es una imagen válida.`,
              icon: "error",
            });
            continue;
          }

          validFiles.push(file);
        }

        // Crear previews y emitir archivos pendientes
        validFiles.forEach((file) => {
          const reader = new FileReader();
          reader.onload = (e) => {
            previews.push(e.target.result);
            this.$emit("input", [...previews]);
          };
          reader.readAsDataURL(file);
        });

        // Emitir los archivos pendientes para que el padre los suba al guardar
        this.$emit("pending-files", validFiles);

        event.target.value = "";
      } else {
        // Imagen única
        const file = files[0];

        // Validar tamaño (5MB máximo)
        if (file.size > 5 * 1024 * 1024) {
          this.$swal?.fire?.({
            title: "Error",
            text: "El archivo es demasiado grande. El tamaño máximo permitido es 5MB.",
            icon: "error",
          });
          event.target.value = "";
          return;
        }

        // Validar tipo de archivo
        if (!file.type.startsWith("image/")) {
          this.$swal?.fire?.({
            title: "Error",
            text: "Por favor, selecciona un archivo de imagen válido.",
            icon: "error",
          });
          event.target.value = "";
          return;
        }

        // Crear preview local
        const reader = new FileReader();
        reader.onload = (e) => {
          this.$emit("input", e.target.result);
        };
        reader.readAsDataURL(file);

        // Emitir el archivo pendiente para que el padre lo suba al guardar
        this.$emit("pending-file", file);
      }
    },

    removeImage() {
      this.$emit("input", null);
      this.$emit("pending-file", null);
    },

    removeImageAt(index) {
      if (Array.isArray(this.value)) {
        const newArray = [...this.value];
        newArray.splice(index, 1);
        this.$emit("input", newArray);
        this.$emit("remove-pending-file", index);
      }
    },
  },
};
</script>

<style scoped>
.field-image {
  width: 100%;
}

.gap-2 {
  gap: 10px;
}
</style>

